const GameFields = {
  totalRounds(overrides = {}) {
    return {
      name: "totalRounds",
      label: "Número de rondas",
      type: "number",
      min: 1,
      max: 50,
      defaultValue: 10,
      required: true,
      ...overrides,
    };
  },

  itemCount(overrides = {}) {
    return {
      name: "itemCount",
      label: "Cantidad de estímulos",
      type: "number",
      min: 2,
      max: 50,
      defaultValue: 12,
      required: true,
      ...overrides,
    };
  },

  targetCount(overrides = {}) {
    return {
      name: "targetCount",
      label: "Cantidad de objetivos",
      type: "number",
      min: 1,
      max: 15,
      defaultValue: 3,
      required: true,
      ...overrides,
    };
  },

  columns(overrides = {}) {
    return {
      name: "columns",
      label: "Número de columnas",
      type: "number",
      min: 2,
      max: 8,
      defaultValue: 4,
      required: true,
      ...overrides,
    };
  },

  displayTime(overrides = {}) {
    return {
      name: "displayTime",
      label: "Tiempo de exposición",
      type: "number",
      min: 250,
      max: 10000,
      step: 250,
      defaultValue: 2000,
      required: true,
      unit: "ms",
      help: "Tiempo durante el que se muestran los estímulos.",
      ...overrides,
    };
  },

  responseTime(overrides = {}) {
    return {
      name: "responseTime",
      label: "Tiempo máximo de respuesta",
      type: "number",
      min: 500,
      max: 30000,
      step: 500,
      defaultValue: 5000,
      required: true,
      unit: "ms",
      ...overrides,
    };
  },

  stimulusDuration(overrides = {}) {
    return {
      name: "stimulusDuration",
      label: "Duración del estímulo",
      type: "number",
      min: 200,
      max: 10000,
      step: 100,
      defaultValue: 1000,
      required: true,
      unit: "ms",
      ...overrides,
    };
  },

  interval(overrides = {}) {
    return {
      name: "interval",
      label: "Intervalo entre estímulos",
      type: "number",
      min: 100,
      max: 10000,
      step: 100,
      defaultValue: 500,
      required: true,
      unit: "ms",
      ...overrides,
    };
  },

  patternLength(overrides = {}) {
    return {
      name: "patternLength",
      label: "Longitud del patrón",
      type: "number",
      min: 2,
      max: 12,
      defaultValue: 4,
      required: true,
      ...overrides,
    };
  },

  startLength(overrides = {}) {
    return {
      name: "startLength",
      label: "Longitud inicial",
      type: "number",
      min: 1,
      max: 10,
      defaultValue: 3,
      required: true,
      ...overrides,
    };
  },

  maxLength(overrides = {}) {
    return {
      name: "maxLength",
      label: "Longitud máxima",
      type: "number",
      min: 2,
      max: 20,
      defaultValue: 8,
      required: true,
      ...overrides,
    };
  },

  showSpeed(overrides = {}) {
    return {
      name: "showSpeed",
      label: "Velocidad de presentación",
      type: "number",
      min: 200,
      max: 3000,
      step: 100,
      defaultValue: 650,
      required: true,
      unit: "ms",
      ...overrides,
    };
  },

  goProbability(overrides = {}) {
    return {
      name: "goProbability",
      label: "Probabilidad de estímulo Go",
      type: "number",
      min: 0.1,
      max: 0.9,
      step: 0.1,
      defaultValue: 0.7,
      required: true,
      help: "Ejemplo: 0.7 equivale al 70 % de estímulos Go.",
      ...overrides,
    };
  },

  maxErrors(overrides = {}) {
    return {
      name: "maxErrors",
      label: "Máximo de errores",
      type: "number",
      min: 1,
      max: 30,
      defaultValue: 5,
      required: true,
      ...overrides,
    };
  },

  repeatedGroups(overrides = {}) {
    return {
      name: "repeatedGroups",
      label: "Grupos repetidos",
      type: "number",
      min: 1,
      max: 10,
      defaultValue: 2,
      required: true,
      ...overrides,
    };
  },

  repetitionsPerGroup(overrides = {}) {
    return {
      name: "repetitionsPerGroup",
      label: "Repeticiones por grupo",
      type: "number",
      min: 2,
      max: 6,
      defaultValue: 2,
      required: true,
      ...overrides,
    };
  },

  similarDistractors(overrides = {}) {
    return {
      name: "similarDistractors",
      label: "Usar distractores parecidos",
      type: "checkbox",
      defaultValue: false,
      help: "Aumenta la dificultad de discriminación visual.",
      ...overrides,
    };
  },

  showLiveScore(overrides = {}) {
    return {
      name: "showLiveScore",
      label: "Mostrar puntuación durante el juego",
      type: "checkbox",
      defaultValue: true,
      ...overrides,
    };
  },

  immediateFeedback(overrides = {}) {
    return {
      name: "immediateFeedback",
      label: "Mostrar corrección inmediata",
      type: "checkbox",
      defaultValue: false,
      ...overrides,
    };
  },
};

export default GameFields;